/**
 * The editor-facing top-spacing scale.
 *
 * Widgets space themselves with top padding only (see "Widget Spacing" in
 * CLAUDE.md), and `pt-4` is the fixed default for all of them. A handful are
 * *section headings* rather than content — they introduce whatever follows —
 * and how much air one of those needs depends on where the editor puts it, not
 * on the component. Those widgets expose this enum as a Strapi field instead of
 * hard-coding a value.
 *
 * Shared rather than declared per widget so the steps cannot drift apart as
 * more widgets adopt the knob. Currently used by the Text Content Widget
 * (`widgets.title-widget`), School Details (`widgets.school-details`), whose
 * header/subtitle pair is a Text Content Widget in all but name, and the Two
 * Column Layout (`layouts.two-column-layout`), whose spacing depends on what an
 * editor puts in its columns.
 *
 * `l` is the default on every widget that has the field, matching the Strapi
 * schema default — entries written before the field existed resolve to it.
 */
export type WidgetSpacing = '0' | 's' | 'm' | 'l' | 'xl';

export const WIDGET_SPACING_CLASS: Record<WidgetSpacing, string> = {
  // No class at all, for a widget an editor wants flush against what is above
  // it — a section container whose first block already brings its own spacing,
  // for instance.
  '0': '',
  's': 'pt-4',
  'm': 'pt-6',
  'l': 'pt-8',
  'xl': 'pt-12',
};

export const DEFAULT_WIDGET_SPACING: WidgetSpacing = 'l';
